/* eslint-disable react/prop-types */
/* eslint-disable react/prefer-stateless-function */
import React from 'react';

import MenuItem from '@material-ui/core/MenuItem';

class OptionComponent extends React.Component {
  render() {
    const { value, text, children, ...rest } = this.props;
    return (
      // eslint-disable-next-line react/jsx-props-no-spreading
      <MenuItem value={value} {...rest}>
        {children}
      </MenuItem>
    );
  }
}

export default OptionComponent;
